window.FBT = {

  currentVariant: null,

  setCurrentVariant(variant) {

    if (!variant) return;

    this.currentVariant = variant;

    console.log("FBT Variant Updated:", variant);

    this.updateCurrentProduct();
  },

  updateCurrentProduct() {

    const variant = this.currentVariant;

    if (!variant) return;

    const card = document.querySelector(
      '.fbt-card[data-current-product="true"]'
    );

    if (!card) {
      console.log("FBT current product card not found");
      return;
    }

    card.dataset.selectedVariant = variant.id;
    card.dataset.price = variant.price;
    card.dataset.comparePrice =
      variant.compare_at_price || 0;

    /*
     * Current product ke variant selects
     * ko bhi update karna
     */

    const selects = card.querySelectorAll(
      ".fbt-variant-select"
    );

    selects.forEach((select) => {

      const optionIndex =
        Number(select.dataset.optionIndex);

      if (optionIndex === 0 && variant.option1) {
        select.value = variant.option1;
      }

      if (optionIndex === 1 && variant.option2) {
        select.value = variant.option2;
      }

    });

    if (
      typeof window.updateFBTTotalPrice === "function"
    ) {
      window.updateFBTTotalPrice();
    }
  }

};


document.addEventListener("DOMContentLoaded", () => {

  const variantInput =
    document.querySelector('[name="id"]');

  if (!variantInput) {
    console.log("FBT: variant input not found");
    return;
  }


  function syncVariant() {

    const variantId =
      Number(variantInput.value);

    if (!variantId) return;

    const selectedVariant =
      window.variants?.find(
        variant =>
          Number(variant.id) === variantId
      );

    if (!selectedVariant) {
      console.log(
        "FBT: variant not found",
        variantId
      );
      return;
    }

    /*
     * Same variant hai toh unnecessary update mat karo
     */
    if (
      Number(this.currentVariant?.id) ===
      Number(selectedVariant.id)
    ) {
      return;
    }

    this.setCurrentVariant(selectedVariant);
  }


  /*
   * INITIAL VARIANT
   */
  syncVariant.call(window.FBT);


  /*
   * Variant input change
   */
  variantInput.addEventListener(
    "change",
    () => {
      syncVariant.call(window.FBT);
    }
  );


  /*
   * Theme ke cases ke liye fallback observer
   */
  let lastVariantId = variantInput.value;

  setInterval(() => {

    const currentVariantId =
      variantInput.value;

    if (currentVariantId === lastVariantId) {
      return;
    }

    lastVariantId = currentVariantId;

    syncVariant.call(window.FBT);

  }, 100);

});